/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Toools - przydatne funkcje
 *
 * @export
 * @class Tools
 * @extends {UrlTools}
 */
import { UrlTools } from "./UrlTools.class";

export class Tools extends UrlTools {
	constructor() {
		super();
	}
	// ****************************************************************************************************
	// zmiana jezyka
	// ****************************************************************************************************
	changeLanguage(jezyk, reloadPage) {
		synchronizeNewsletterByChangeLang(jezyk);

		if (reloadPage === undefined)
			reloadPage = false;
		this.setCookie('jezyk', jezyk, 300);
		this.setCookie('pytanieJezyk', 'tak', 45);
		if (reloadPage)
			location.reload();
	}
	// ****************************************************************************************************
	// zmiana waluty
	// ****************************************************************************************************
	changeCurrency(waluta) {
		this.setCookie('currency', waluta, 300);
		if (location.pathname == '/login')
			location.pathname = '/';
		else
			location.reload();
	}
	// ****************************************************************************************************
	// wyświetlanie modalowego "alertu"
	// ****************************************************************************************************
	showModalAlert(txt, title, classExtended, onClose) {
		if ( title === undefined )
			title = TXT_MSG;
		if ( onClose === undefined && typeof classExtended === "function" ) {
			onClose = classExtended;
			classExtended = '';
		} else {
			if ( classExtended === undefined )
				classExtended = '';
			else
				classExtended = ' ' + classExtended;
			if ( onClose === undefined )
				onClose = function(){};
		}
		$("<div id='modalDIV'></div>").appendTo($('body'));
		$('#modalDIV').html('<div class="modal fade pr-0" id="modalAlert" tabindex="-1" role="dialog" aria-labelledby="modalAlertTitle" aria-hidden="true">' +
			'<div class="modal-dialog modal-dialog-centered' + classExtended + '" role="document">' +
			'<div class="modal-content">' +
			'<div class="modal-header">' +
			'<h5 class="modal-title" id="modalAlertTitle">' + title + '</h5>' +
			'<button type="button" class="close" data-dismiss="modal" aria-label="' + TXT_CLOSE + '"><span aria-hidden="true">&times;</span></button>' +
			'</div>' +
			'<div class="modal-body text-center">' + txt + '</div>' +
			'<div class="modal-footer justify-content-center"><button type="button" class="btn btn-primary" data-dismiss="modal">' + TXT_CLOSE + '</button></div>' +
			'</div>' +
			'</div>' +
			'</div>');
		$('#modalAlert').modal('show');
		$('#modalAlert').on('hidden.bs.modal', function(e) {
			$(this).modal('dispose');
			$("#modalDIV").remove();
			onClose();
		});
	}
	// ****************************************************************************************************
	// wyświetlanie modalowego "alertu"
	// ****************************************************************************************************
	showModalConfirmAlert(txt, title, classExtended, yesTxt, onYes, noTxt, onNo) {
		if ( title === undefined || title == '')
			title = TXT_MSG;
		if ( title === undefined )
			classExtended = '';
		if ( yesTxt === undefined )
			yesTxt = 'Yes';
		if ( onYes === undefined )
			onYes = function(){};
		if ( noTxt === undefined )
			noTxt = 'No';
		if ( onNo === undefined )
			onNo = function(){};
		let onNoMode = false;

		$("<div id='modalDIV'></div>").appendTo($('body'));
		$('#modalDIV').html('<div class="modal fade pr-0" id="modalAlert" tabindex="-1" role="dialog" aria-labelledby="modalAlertTitle" aria-hidden="true">' +
			'<div class="modal-dialog modal-dialog-centered' + classExtended + '" role="document">' +
			'<div class="modal-content">' +
			'<div class="modal-header">' +
			'<h5 class="modal-title" id="modalAlertTitle">' + title + '</h5>' +
			'<button type="button" class="close" data-dismiss="modal" aria-label="' + yesTxt + '"><span aria-hidden="true">&times;</span></button>' +
			'</div>' +
			'<div class="modal-body text-left">' + txt + '</div>' +
			'<div class="modal-footer justify-content-center"><button type="button" class="btn btn-primary" data-dismiss="modal">' + yesTxt + '</button><button id="modalAlertOnNoBtn" type="button" class="btn btn-primary">' + noTxt + '</button></div>' +
			'</div>' +
			'</div>' +
			'</div>');
		$('#modalAlert').modal('show');
		$('#modalAlertOnNoBtn').on('click', function(){
			onNoMode = true;
			onNo();
			$('#modalAlert').modal('hide');
		});
		$('#modalAlert').on('hidden.bs.modal', function (e) {
			$(this).modal('dispose');
			$("#modalDIV").remove();
			if (!onNoMode)
				onYes();
		});
	}
	// ****************************************************************************************************
	// wyświetlanie znikającego "alertu"
	// ****************************************************************************************************
	showToastAlert(txt, title, autoHide) {
		/////// PORZUCONE!!!!trzeba dopracować
		var autoHideT = (autoHide) ? 'true' : 'false';
		$('<div id="toastAlert" role="alert" aria-live="assertive" aria-atomic="true" class="toast" data-autohide="' + autoHideT + '" data-delay="5000"></div>').appendTo($('body'));
		$('#toastAlert').html('' +
			'<div class="toast-header">' +
			'<strong class="mr-auto">' + title + '</strong>' +
			'<button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="' + TXT_CLOSE + '"><span aria-hidden="true">&times;</span></button>' +
			'</div>' +
			'<div class="toast-body">' + txt + '</div>' +
			'</div>');
		$('#toastAlert').toast('show');
		$('#toastAlert').on('hidden.bs.toast', function (e) {
			$(this).toast('dispose').remove();
		});
	}

	// ****************************************************************************************************
	// animowany scroll do id
	// ****************************************************************************************************
	scrollTo(target, offset) {
		if ( offset === undefined )
			offset = 0;

		if ( $(target).length > 0 ) {
			$('html,body').animate({
				scrollTop: $(target).offset().top - $('body').css('padding-top').replace(/([a-z])+/g, '') + offset
			},'slow');
		}
	}

	// ****************************************************************************************************
	// animowany scroll do id na podstawie classy
	// ****************************************************************************************************
	initScrollTo(clss, marker) { // inna wersja : PAGEOBJT -> initScrollToHash
		var that = this;

		if ( marker === undefined )
			marker = false;

		if ( $(clss).length > 0 ) {
			$(clss).each(function(i,e){
				var el = $(e);
				var hash = el.attr('href'); // proba pobrana href
				var offset = el.data("offset");

				if ( typeof hash === 'undefined' || hash === false || hash === null ) { // brak href
					hash = el.data('hash'); // proba pobrana data-hash
				}

				if ( typeof offset === 'undefined' || offset === false || offset === null ) { // brak offset
					offset = 0;
				}

				if ( hash !== null ) {
					el.off('click').on('click', function(event){
						$(clss).removeClass('active');

						event.preventDefault();
						event.stopPropagation();

						that.scrollTo(hash, offset);
						if ( marker ) {
							el.addClass('active');
						}
					});
				}
			});
		}
	}
}